import { render, staticRenderFns } from "./RecordRelease.vue?vue&type=template&id=5d3ab270&"
import script from "./RecordRelease.vue?vue&type=script&lang=js&"
export * from "./RecordRelease.vue?vue&type=script&lang=js&"
import style0 from "./RecordRelease.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports